import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs, Modal, Col, Nav, Row } from "react-bootstrap";
// import cart from "../../assets/images/cart.svg";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import AddonCard from "../../component/addonCard";
import { ToastMsg } from "../TostMsg";
const animations = {
  initial: { opacity: 0, x: 400 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};

const AddOnSettings = () => {
  const [showConfirm, setShowConfirm] = useState(false);

  const { sidebar, permissions } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState("0");

  const [addons, setAddons] = useState({
    free: [],
    paid: [],
    my: [],
    all: [],
  });

  const today = new Date();

  const oneMonthLater = new Date(today);
  oneMonthLater.setMonth(today.getMonth() + 1);

  const [enableDisableAddDet, setEnableDisaleAddOnDet] = useState({});

  const handleShowConfirm = (addon) => {
    setEnableDisaleAddOnDet(addon);
    setShowConfirm(true);
  };
  const handleCloseConfirm = () => setShowConfirm(false);

  const getAddons = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_ADDONS_LIST).then((res) => {
      if (res?.json?.Success) {
        let addons = res?.json?.Data;

        setAddons({
          free: addons?.FreeAddons,
          paid: addons?.PaidAddons,
          my: addons?.MyAddons,
          all: addons?.AllAddons,
        });
      }
    });
  };

  useEffect(() => {
    getAddons();
  }, []);

  const enableDisAbleAddon = () => {
    let payload = {
      AddonInfoId: enableDisableAddDet?.AddonInfoId,
      Activate: !enableDisableAddDet?.IsActive,
      SubscriptionEnd: oneMonthLater,
      AutoRenew: false,
      AddonConfig: "",
    };

    PostCallWithErrorResponse(
      ApiConfig.ENABLE_DISABLE_ADDON,
      JSON.stringify(payload),
    ).then((res) => {
      if (res?.json?.Success) {
        ToastMsg("success", res?.json?.Message);
        getAddons();
      } else {
        ToastMsg("error", res?.json?.Message);
      }

      handleCloseConfirm();
    });
  };

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div id="cx-wrapper" className="Add_on_setting">
          <div className="main-master-wrapper new-scroll">
            <div className="Heading">
              <p>Web Application Add-ons</p>
                {permissions && permissions["View My Card"] && (
              <Link to="/AddOnSettingsCart">
                <button className="cx-btn-3">
                  {/* <img src={cart} alt="" /> */}
                  My Cart
                </button>
              </Link>
                )}
            </div>

            <div
              className="add-on-tabs-wrapper"
              id="scroll_insideThe_Padding83"
            >
              <Tab.Container
                id="left-tabs-example"
                className="aot-tab-wrapper"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <Row>
                  <Col sm={12} className="outer-tab-add-on-setting">
                    <Nav variant="pills" className="aot-nav">
                    {permissions && permissions["View My Add-ons"] && (
                      <Nav.Item className="aot-tab">
                        <Nav.Link className="aot-link" eventKey="0">
                          My Add-ons
                        </Nav.Link>
                      </Nav.Item>
                    )}

                      {permissions && permissions["View Premium Add-ons"] && (
                      <Nav.Item className="aot-tab">
                        <Nav.Link className="aot-link" eventKey="1">
                          Premium Add-ons
                        </Nav.Link>
                      </Nav.Item>
                      )}

                        {permissions && permissions["View Premium Add-ons"] && (
                      <Nav.Item className="aot-tab">
                        <Nav.Link className="aot-link" eventKey="2">
                          Free Add-ons
                        </Nav.Link>
                      </Nav.Item>
                        )}
                    </Nav>
                  </Col>

                  <Col sm={12}>
                    <Tab.Content>
                      {/* === My Add-ons === */}
                      
                        <Tab.Pane eventKey="0">
                          <div className="add-on-card-wrapper">
                            <div className="row">
                              {addons?.my?.map((addon, index) => (
                                <AddonCard
                                  addon={addon}
                                  index={index}
                                  handleShowConfirm={(add) =>
                                    handleShowConfirm(add)
                                  }
                                />
                              ))}
                            </div>
                          </div>

                          <div className="bottom-notes-section">
                            <div className="note-left">
                              <p>
                                <span className="red-star">*</span> Subscription
                                cycle - First day of every month
                              </p>
                            </div>
                            <div className="total-right">
                              <p>Total monthly Subscription - ₹300</p>
                            </div>
                          </div>
                        </Tab.Pane>
                     
                      {/* === Premium Add-ons === */}
                      <Tab.Pane eventKey="1">
                        <div className="add-on-card-wrapper">
                          <div className="row">
                            {addons?.paid?.map((addon, index) => (
                              <AddonCard
                                addon={addon}
                                index={index}
                                handleShowConfirm={(add) =>
                                  handleShowConfirm(add)
                                }
                              />
                            ))}
                          </div>
                        </div>

                        <div className="bottom-notes-section">
                          <div className="note-left">
                            <p>
                              <span className="red-star">*</span> Subscription
                              cycle - First day of every month
                            </p>
                          </div>
                        </div>
                      </Tab.Pane>

                      {/* === Free Add-ons === */}
                      <Tab.Pane eventKey="2">
                        <div className="add-on-card-wrapper">
                          <div className="row">
                            {addons?.free?.map((addon, index) => (
                              <AddonCard
                                addon={addon}
                                index={index}
                                handleShowConfirm={(add) =>
                                  handleShowConfirm(add)
                                }
                              />
                            ))}
                          </div>
                        </div>

                        <div className="bottom-notes-section">
                          <div className="note-left">
                            <p>
                              <span className="red-star">*</span> Subscription
                              cycle - First day of every month
                            </p>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>

          {/* === Confirmation Modal === */}
          <Modal
            show={showConfirm}
            onHide={handleCloseConfirm}
            centered
            className="common-model"
          >
            <Modal.Body>
              Do you want to{" "}
              {enableDisableAddDet?.IsActive ? "disable" : "enable"} this
              feature?
            </Modal.Body>
            <Modal.Footer className="pop-up-modal-footer btn-wrapper">
              <button className="cx-btn-1" onClick={handleCloseConfirm}>
                Cancel
              </button>
              <button className="cx-btn-2" onClick={enableDisAbleAddon}>
                Yes
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AddOnSettings;
